import React, { Component } from "react";
import styled from "styled-components/macro";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";

import { MainContext } from "../App.js";

import Procon from "../Assets/procons.js";
import Wrapper from "../Styles/wrapper";
import Grid, { Active, Hex } from "../Styles/grid";

//Load from Config
import Config from "../Config/profile.json";
class Profile extends Component {
  render() {
    if (this.props.location.pathname !== "/") {
      return (
        <>
          <MainContext.Consumer>
            {context => (
              <Link to="/" replace>
                <Wrapper grey>
                  <Grid icon>
                    {Config.map(profile => {
                      if (profile.Slug === `${context.bit}`) {
                        return (
                          <Active icon key={profile.id}>
                            <Procon name={profile.Slug} color={profile.Slug} />
                            <Title>{profile.Slug}</Title>
                          </Active>
                        );
                      } else {
                        return (
                          <button
                            key={profile.id}
                            onClick={number => context.mainToggle(profile.Slug)}
                          >
                            <Procon name={profile.Slug} color="grey" />
                            <Title>{profile.Slug}</Title>
                          </button>
                        );
                      }
                    })}
                  </Grid>
                </Wrapper>
              </Link>
            )}
          </MainContext.Consumer>
        </>
      );
    }

    return (
      <>
        <Helmet>
          <title>Profiles | Wiha BitFinder</title>
        </Helmet>
        <MainContext.Consumer>
          {context => (
            <Wrapper>
              <h2>Choose A Profile</h2>
              <Grid>
                {Config.map(profile => {
                  return (
                    <button
                      key={profile.id}
                      onClick={number => context.mainToggle(profile.Slug)}
                    >
                      <Title>{profile.Name}</Title>
                      <Procon name={profile.Slug} color={profile.Slug} />
                    </button>
                  );
                })}
              </Grid>
              <Grid subprofile>
                {context.bit != null &&
                  Object.values(
                    Config.find(number => number.Slug === `${context.bit}`).Type
                  ).map(items =>
                    context.bit !== "hex" ? (
                      <Link
                        to={`${context.bit}-${items.slug}/`}
                        onClick={thing => context.subSet(items.slug)}
                        key={items.slug}
                      >
                        <button>
                          <Title>{items.profile}</Title>
                        </button>
                      </Link>
                    ) : (
                      <Hex key={items.slug}>
                        <Link
                          to={`${context.bit}-${items.slug}/`}
                          onClick={thing => context.subSet(items.slug)}
                        >
                          <button>
                            <Title>{items.profile}</Title>
                          </button>
                        </Link>
                      </Hex>
                    )
                  )}
              </Grid>
              <Info>
                Can't find the bit that you need, find thousands more at{" "}
                <a href="https://wihatools.com/bits">
                  https://wihatools.com/bits.
                </a>
              </Info>
            </Wrapper>
          )}
        </MainContext.Consumer>
      </>
    );
  }
}
Profile.contextType = MainContext;

export default Profile;

const Title = styled.p`
  text-transform: uppercase;
  font-weight: bolder;
`;

const Info = styled.p`
  clear: both;
`;
